import {
  getRegionDisplayName,
  getTargetProductForAbsThemes,
  getTargetRegionForAbsThemes,
} from '@/creditflowresearch/ui/components/creditFlow/articles/common/useGetLinkToAllArticles/helpers';
import {
  ILinkConfig,
} from '@/creditflowresearch/ui/components/creditFlow/articles/common/useGetLinkToAllArticles/interfaces';
import { getRegionsFromMarkets } from '@/creditflowresearch/ui/common/utils/regions/getRegionsFromMarkets';
import { EmergingMarket } from '@/creditflowresearch/domain/Market';
import Region from '@/creditflowresearch/domain/Region';
import URL from '@/creditflowresearch/Router/urlConstants';
import { removeQueryParams } from '@framework/router';

export const linkToAllArticlesConfig: ILinkConfig[] = [
  {
    match: ({ query }) => query.markets?.includes(EmergingMarket.ABBREVIATION),
    getProduct: () => '',
    getRegion: ({ query }) => getRegionsFromMarkets(query.markets).toString() || Region.LATM_ABBREVIATION,
    getConfiguredQuery: ({ query }) => removeQueryParams(query, ['segments']),
    path: URL.MARKET_OVERVIEW_EM,
  },
  {
    match: () => true,
    getProduct: ({ query, deal, filters }) => {
      const activeProducts = filters.products.filter(({ isActive }) => isActive);
      return getTargetProductForAbsThemes(activeProducts, filters.accessibleProducts, query.products as string, deal);
    },
    getRegion: ({ query, deal, filters }) => {
      const activeRegions = filters.regions.filter(({ isActive }) => isActive);
      const regions = query?.regions?.toString() || getRegionsFromMarkets(query.markets).toString();
      const targetRegions = getTargetRegionForAbsThemes(
        activeRegions,
        filters.accessibleRegions,
        regions,
        deal,
      );
      return targetRegions ? getRegionDisplayName(targetRegions) : Region.USOA_ABBREVIATION;
    },
    getConfiguredQuery: ({ query }) => query,
    path: '',
  },
];
